import { BOAT_DIMENSIONS, COLORS, MATERIAL_PROPERTIES } from './constants';

/**
 * WaterSurface component - renders a transparent plane at y=0 (waterline)
 * The plane is sized relative to the hull length for proper visual context
 */
export const WaterSurface = () => {
  const waterSize = BOAT_DIMENSIONS.HULL_LENGTH * MATERIAL_PROPERTIES.WATER_SURFACE_SCALE;

  return (
    <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, -0.01, 0]} receiveShadow>
      <planeGeometry args={[waterSize, waterSize]} />
      <meshStandardMaterial
        color={COLORS.WATER}
        transparent
        opacity={COLORS.WATER_OPACITY}
        roughness={MATERIAL_PROPERTIES.WATER_ROUGHNESS}
        metalness={MATERIAL_PROPERTIES.WATER_METALNESS}
      />
    </mesh>
  );
};
